export function escapeHtml(value: string): string {
  const matches = value.match(/(<([^>]+)>)/gi);
  if (matches) {
    for (const matchedValue of matches) {
      value = value.replace(matchedValue, '');
    }
  }
  return value;
}
